import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6dd03f5c&scoped=true"
import script from "./component.js?vue&type=script&lang=js&external"
export * from "./component.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=6dd03f5c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd03f5c",
  null
  
)

export default component.exports